/**
 * Checks if a product exists in the cart based on its productId.
 * @param {String} productId - The ID of the product to check.
 * @param {String[]} cart - Cart Data Object.
 * @returns {Boolean} indicating whether the product is in the cart.
 */

export const isProductInCart = (
  productId: string,
  cart: { allCarts?: { nodes?: { cartItemProductId: string }[] } }
): boolean => {
  // Ensure the cart exists and check if the product is in it
  return cart?.allCarts?.nodes?.some(
    (cartItem: { cartItemProductId: string }) => cartItem.cartItemProductId === productId
  ) || false // Default to false if the cart is undefined
}
